import type { MouseEvent } from "react";
import { TextFormatIcon } from "@/icons/widget-menu";
import type { ActiveSubMenuState, MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";

interface UseTextFormatButtonProps {
    activeSubMenu: ActiveSubMenuState | null;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useTextFormatButton({
    activeSubMenu,
    setActiveSubMenu,
}: UseTextFormatButtonProps): MenuOptionResult {
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) =>
            prev?.name === "textFormat" ? null : { name: "textFormat", anchor: button },
        );
    };

    const isActive = activeSubMenu?.name === "textFormat";

    const content = <TextFormatIcon className={isActive ? styles.svgStrokeActive : ""} />;

    return {
        content,
        handleClick,
        isActive,
    };
}
